<script setup>
    // Vue
    import { defineProps, defineModel, defineEmits } from 'vue';

    // Utils
    import Utils from '@/commonProject/helpers/utils.js';

    // Else
    import i18n from '@/common/i18n';
    // ----------------------------
    // Props
    // ----------------------------
    const props = defineProps({
        options: {
            type: Array,
            required: true,
        },
        placeholder: {
            type: String,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
    });

    // ----------------------------
    // v-model
    // ----------------------------
    const model = defineModel();
    // ----------------------------
    // emit
    // ----------------------------
    const emit = defineEmits(['childEmit']);
    // ----------------------------
    // 関数
    // ----------------------------
    function emitEvent() {
        emit('childEmit');
    }
</script>

<template>
    <div class="select">
        <select v-model="model" :required="required" @change="emitEvent()">
            <option value="">
                <!--選択してください-->
                {{ Utils.isNullEmpty(props.placeholder) ? i18n.global.t('common.parts.selectOptionDefault') : props.placeholder }}
            </option>
            <option v-for="option in options" :key="option.id" :value="option.pk">
                {{ option.name }}
            </option>
        </select>
    </div>
</template>

<style></style>
